import React, { useEffect } from "react"

// Birdeye reviews embed. The vendor script is an IIFE that finds the target
// div by id and injects the reviews iframe into it.
const WIDGET_ID = "1234567893011151831541754"
const SCRIPT_SRC =
  "https://birdeye.com/embed/v7/175447492020027/11/1234567893011151831541754"

const BirdeyeReviews = () => {
  useEffect(() => {
    // Re-inject on mount so the widget populates whichever page renders it
    // (client-side navigation keeps the old script in the DOM, but re-running
    // it re-targets the current page's div).
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`)
    if (existing) existing.remove()
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = SCRIPT_SRC
    script.async = true
    document.body.appendChild(script)
  }, [])

  return <div id={`bf-revz-widget-${WIDGET_ID}`}></div>
}

export default BirdeyeReviews
